"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, prefetch } from "@opensea/graphql";
import { ACTIVITY_TYPES_COOKIE_NAME, FALLBACK_ACTIVITY_TYPES, parseActivityTypes } from "@opensea/navigation";
import Cookies from "js-cookie";
import { useState } from "react";
import { ActivityFeedTableRowFragment } from "@/components/activity-feed/ActivityFeedTableRow.fragment";
import { ACTIVITY_FEED_PAGE_SIZE } from "@/components/activity-feed/constants";
import { ActivitySideBarFeedTableRowFragment } from "@/components/activity-feed/side-bar/ActivitySideBarFeedTableRow.fragment";
import { MintFeedTableRowFragment } from "@/components/collection/drops/components/MintFeed/MintFeedTableRow.fragment";
import { SalesFeedTableRowFragment } from "@/components/collection/drops/components/SalesFeed/SalesFeedTableRow.fragment";
import { usePaginatedQuery } from "../use-paginated-query";
import { useCollectionActivitySubscription } from "./use-collection-activity-subscription";
const UseCollectionActivityQuery = graphql(`
    query UseCollectionActivityQuery(
      $collectionSlug: String!
      $filter: CollectionActivityFilterInput
      $cursor: String
      $limit: Int!
    ) {
      collectionActivity(
        collectionSlug: $collectionSlug
        filter: $filter
        cursor: $cursor
        limit: $limit
      ) {
        items {
          id
          eventTime
          ...ActivityFeedTableRow
          ...ActivitySideBarFeedTableRow
          ...SalesFeedTableRow
          ...MintFeedTableRow
        }
        nextPageCursor
      }
    }
  `, [ActivityFeedTableRowFragment, ActivitySideBarFeedTableRowFragment, SalesFeedTableRowFragment, MintFeedTableRowFragment]);
export function useCollectionActivity(variables, t0) {
  const $ = _c(17);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  let t2;
  if ($[2] !== variables) {
    t2 = {
      query: UseCollectionActivityQuery,
      variables
    };
    $[2] = variables;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== options || $[5] !== variables.limit) {
    t3 = {
      pageSize: variables.limit,
      ...options
    };
    $[4] = options;
    $[5] = variables.limit;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    items,
    setItems,
    pagination,
    error,
    noResults
  } = usePaginatedQuery(t2, _temp, t3);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = new Map();
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const [itemsLiveAddedAt, setItemsLiveAddedAt] = useState(t4);
  let subscriptionVariables;
  if ($[8] !== variables) {
    const {
      limit: _l,
      ...t5
    } = variables;
    subscriptionVariables = t5;
    $[8] = variables;
    $[9] = subscriptionVariables;
  } else {
    subscriptionVariables = $[9];
  }
  useCollectionActivitySubscription(subscriptionVariables, setItems, setItemsLiveAddedAt, pagination);
  let t5;
  if ($[10] !== error || $[11] !== items || $[12] !== itemsLiveAddedAt || $[13] !== noResults || $[14] !== pagination || $[15] !== setItems) {
    t5 = {
      items,
      setItems,
      pagination,
      itemsLiveAddedAt,
      error,
      noResults
    };
    $[10] = error;
    $[11] = items;
    $[12] = itemsLiveAddedAt;
    $[13] = noResults;
    $[14] = pagination;
    $[15] = setItems;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
function _temp(v) {
  return v?.collectionActivity;
}
export const prefetchUseCollectionActivityQuery = (collectionSlug, client) => {
  const activityTypes = parseActivityTypes(Cookies.get(ACTIVITY_TYPES_COOKIE_NAME)) ?? FALLBACK_ACTIVITY_TYPES;
  prefetch(client, UseCollectionActivityQuery, {
    collectionSlug,
    filter: {
      activityTypes,
      attributes: [],
      markets: [],
      numericTraitRange: []
    },
    limit: ACTIVITY_FEED_PAGE_SIZE
  });
};